<template>
  <transition name="el-fade-in-linear">
    <div class="course-type">
      <div class="selfConstruct indexTab" style="position: relative">
        <!-- <img src="../../assets/image/picture/bgg1.jpg" class="bgg" style="
          opacity: 0.2;
          position: absolute;
          top: -760px;
          z-index: -1;
          width: 100%;
        " /> -->
        <!-- 6块小的专题专栏 -->
        <div class="wrap clearfix">
          <div class="fl Item tabBox">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3>参政议政</h3>
              </div>
              <p @click="czyz_toMore()" style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="(item, index) in one" :key="index" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a>{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <div class="fl Item tabBox">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3>社会服务</h3>
              </div>
              <p @click="
                shfw_toMore()
                " style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="(item, index) in two.slice(0, 6)" :key="index" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a>{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <div class="fl Item tabBox">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3>思想建设</h3>
              </div>
              <p @click="sx_zz_jg_toMore('1146098033667080192', '思想建设')" style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="(item, index) in three.slice(0, 6)" :key="index" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
                ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a>{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <div class="fl Item tabBox">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3>组织建设</h3>
              </div>
              <p @click="
                sx_zz_jg_toMore('1151091253635448832', '组织建设')
                " style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="(item, index) in four.slice(0, 6)" :key="index" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a>{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <!-- 机关建设 -->
          <div class="fl Item tabBox">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3>机关建设</h3>
              </div>
              <p @click="sx_zz_jg_toMore('1146098315738218496', '机关建设')" style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="(item, index) in five.slice(0, 6)" :key="index" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a>{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <!-- 专委会 -->
          <div class="fl Item tabBox">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3 style="padding: 0px 10px;">专委会</h3>
              </div>
              <p @click="zwhMore" style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="item in committeeList" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a class="head_title">{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <!-- 工作机构 5块 包含轮播图 -->
          <div class="fl Item tabBox" style="width: 100%">
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3 style="padding: 0px 10px;">工作机构</h3>
              </div>
            </div>
            <div class="column-box">
              <!-- 1.陕西九三学社医疗服务团 -->
              <div class="fl Item1 tabBox news-column"
                style="box-shadow: none;width: 365px;height: 320px;margin-right: 5px;margin-left: 30px;">
                <!-- 顶部标题名字 -->
                <div class="tabNav1 clearfix" style="position: relative">
                  <!-- 循环 -->
                  <div class="text" @click="columnMore('1306946679664017408', '陕西九三学社医疗服务团')">
                    <div class="title" style="padding: 0px 10px;font-size: 19px;">陕西九三学社医疗服务团</div>
                  </div>
                  <!-- <p style="
                line-height: 70px;
                position: absolute;
                right: 8px;
                color: #1e74cd;
              " class="zhuanlan_more">
                    更多
                  </p> -->
                </div>
                <!-- 新闻列表 -->
                <div class="tabContainer" style="padding: 10px 0px 0px 0px;margin-left: -9px;">
                  <ul v-for="item in six.slice(0, 6)" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                    <div style="display: flex" @click="gotoDetail(item.id)">
                      <li class="li001" style="display: flex;width: 350px;">
                        <!-- 小三角形 -->
                        <!-- <div
                          style="margin-top: 5px;margin-right: -8px;width: 0;height: 0;border-top: 6px solid transparent;border-bottom: 6px solid transparent;border-left: 6px solid #323232;">
                        </div> -->
                        <a>{{ item.title }}</a>
                      </li>
                      <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                    </div>
                  </ul>
                </div>
              </div>
              <!-- 2.轮播图 -->
              <Carousel></Carousel>
              <!-- 3.陕西九三学社科研产业合作座谈会 -->
              <div class="fl Item1 tabBox news-column"
                style="box-shadow: none;width: 385px;height: 320px;margin-left: 21px;">
                <!-- 顶部标题名字 -->
                <div class="tabNav1 clearfix" style="position: relative">
                  <!-- 循环 -->
                  <div class="text" @click="columnMore('1306946600525889536', '陕西九三学社科研产业合作座谈会')">
                    <div class="title" style="padding: 0px 10px;font-size: 19px;">陕西九三学社科研产业合作座谈会</div>
                  </div>
                  <!-- <p  style="
                line-height: 70px;
                position: absolute;
                right: 8px;
                color: #1e74cd;
              " class="zhuanlan_more">
                    更多
                  </p> -->
                </div>
                <!-- 新闻列表 -->
                <div class="tabContainer" style="padding: 10px 0px 0px 0px;margin-left: -9px;">
                  <ul v-for="item in seven.slice(0, 6)" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                    <div style="display: flex" @click="gotoDetail(item.id)">
                      <li class="li001" style="display: flex;width: 350px;">
                        <!-- 小三角形 -->
                        <!-- <div
                          style="margin-top: 5px;margin-right: -8px;width: 0;height: 0;border-top: 6px solid transparent;border-bottom: 6px solid transparent;border-left: 6px solid #323232;">
                        </div> -->
                        <a>{{ item.title }}</a>
                      </li>
                      <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                    </div>
                  </ul>
                </div>
              </div>
              <!-- 4.陕西九三学社碳中和研究院 -->
              <div class="fl Item1 tabBox news-column"
                style="box-shadow: none;width: 360px;height: 320px;margin-left: 30px;margin-top: -35px">
                <!-- 顶部标题名字 -->
                <div class="tabNav1 clearfix" style="position: relative">
                  <!-- 循环 -->
                  <div class="text" @click="columnMore('1308104488640315392', '陕西九三学社碳中和研究院')">
                    <div class="title" style="padding: 0px 10px;font-size: 19px;">陕西九三学社碳中和研究院</div>
                  </div>
                  <!-- <p  style="
                line-height: 70px;
                position: absolute;
                right: 8px;
                color: #1e74cd;
              " class="zhuanlan_more">
                    更多
                  </p> -->
                </div>
                <!-- 新闻列表 -->
                <div class="tabContainer" style="padding: 10px 0px 0px 0px;margin-left: -9px;">
                  <ul v-for="item in eight.slice(0, 6)" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                    <div style="display: flex" @click="gotoDetail(item.id)">
                      <li class="li001" style="display: flex;width: 350px;">
                        <!-- 小三角形 -->
                        <!-- <div
                          style="margin-top: 5px;margin-right: -8px;width: 0;height: 0;border-top: 6px solid transparent;border-bottom: 6px solid transparent;border-left: 6px solid #323232;">
                        </div> -->
                        <a>{{ item.title }}</a>
                      </li>
                      <!-- <li class="li-time" style="color: #8c8c8c">
                        {{ item.releaseTime }}
                      </li> -->
                    </div>
                  </ul>
                </div>
              </div>
              <!-- 5.陕西九三学社乡村振兴研究院 -->
              <div class="fl Item1 tabBox news-column"
                style="box-shadow: none;width: 400px;height: 320px;margin-left: 10px;margin-top: -35px">
                <!-- 顶部标题名字 -->
                <div class="tabNav1 clearfix" style="position: relative">
                  <!-- 循环 -->
                  <div class="text" @click="columnMore('1308104428946980864', '陕西九三学社乡村振兴研究院')">
                    <div class="title" style="padding: 0px 10px;font-size: 19px;">陕西九三学社乡村振兴研究院</div>
                  </div>
                  <!-- <p  style="
                line-height: 70px;
                position: absolute;
                right: 8px;
                color: #1e74cd;
              " class="zhuanlan_more">
                    更多
                  </p> -->
                </div>
                <!-- 新闻列表 -->
                <div class="tabContainer" style="padding: 10px 0px 0px 0px;margin-left: -9px;">
                  <ul v-for="item in nine.slice(0, 6)" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                    <div style="display: flex" @click="gotoDetail(item.id)">
                      <li class="li001" style="display: flex;width: 350px;">
                        <!-- 小三角形 -->
                        <!-- <div
                          style="margin-top: 5px;margin-right: -8px;width: 0;height: 0;border-top: 6px solid transparent;border-bottom: 6px solid transparent;border-left: 6px solid #323232;">
                        </div> -->
                        <a>{{ item.title }}</a>
                      </li>
                      <!-- <li class="li-time" style="color: #8c8c8c">
                        {{ item.releaseTime }}
                      </li> -->
                    </div>
                  </ul>
                </div>
              </div>
              <!-- 6.九三学社稻地江村乡村振兴融合实践基地 -->
              <div class="fl Item1 tabBox news-column"
                style="box-shadow: none;width: 385px;height: 320px;margin-left: 10px;margin-top: -35px">
                <!-- 顶部标题名字 -->
                <div class="tabNav1 clearfix" style="position: relative">
                  <!-- 循环 -->
                  <div class="text" @click="columnMore('1306946543533686784', '九三学社稻地江村乡村振兴融合实践基地')">
                    <div class="title" style="padding: 0px 10px;font-size: 19px;">九三学社稻地江村乡村振兴融合实践基地</div>
                  </div>
                  <!-- <p  style="
                line-height: 70px;
                position: absolute;
                right: 8px;
                color: #1e74cd;
              " class="zhuanlan_more">
                    更多
                  </p> -->
                </div>
                <!-- 新闻列表 -->
                <div class="tabContainer" style="padding: 10px 0px 0px 0px;margin-left: -9px;">
                  <ul v-for="item in ten.slice(0, 6)" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 0px 10px;
              ">
                    <div style="display: flex" @click="gotoDetail(item.id)">
                      <li class="li001" style="display: flex;width: 350px;">
                        <!-- 小三角形 -->
                        <!-- <div
                          style="margin-top: 5px;margin-right: -8px;width: 0;height: 0;border-top: 6px solid transparent;border-bottom: 6px solid transparent;border-left: 6px solid #323232;">
                        </div> -->
                        <a>{{ item.title }}</a>
                      </li>
                      <!-- <li class="li-time" style="color: #8c8c8c">
                        {{ item.releaseTime }}
                      </li> -->
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- -------------------------------------------------------------- -->
          <!-- 历史回眸 -->
          <div class="fl Item tabBox" v-if="false">
            <!-- 顶部标题名字 -->
            <div class="tabNav clearfix" style="position: relative">
              <!-- 循环 -->
              <div class="txt fl">
                <h3>历史回眸</h3>
              </div>
              <p @click="syfcMore" style="
                line-height: 70px;
                position: absolute;
                right: 13px;
                color: #1e74cd;
              " class="zhuanlan_more">
                更多>
              </p>
            </div>
            <!-- 新闻列表 -->
            <div class="tabContainer">
              <ul v-for="item in sheyuanList.slice(0, 6)" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px px 10px;
              ">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a class="head_title">{{ item.title }}</a>
                  </li>
                  <!-- <li class="li-time" style="color: #8c8c8c">
                    {{ item.releaseTime }}
                  </li> -->
                </div>
              </ul>
            </div>
          </div>
          <!-- 电子期刊 -->
          <div class="fl Item tabBox dzqk" style="width:100%;margin-left: 2px;">
            <div class="tabNav clearfix" style="position: relative">
              <div class="txt fl">
                <h3>电子期刊</h3>
              </div>
              <p @click="toEBookMore" style="line-height: 70px;position: absolute;right: 13px;color: #1e74cd;"
                class="zhuanlan_more">
                更多>
              </p>
            </div>

            <!-- 期刊列表 -->
            <div style="display: flex;margin-left: 25px;" class="swiper">
              <div v-for="(item, index) in EBookList" :key="index">
                <div class="ebook-item" @click="gotoDetail(item.id)">
                  <img class="img" :src="`http://www.shx93.gov.cn/prod-api${item.coverImage}`" alt="封面图片">
                </div>
              </div>
            </div>

            <!-- <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="swiper"
          >
            <swiper-slide
              v-for="(item, index) in EBookList"
              :key="index"
              class="swiper_item"
              @click.native="gotoDetail(item.id)"
            >
              <img
                class="img"
                :src="`https://jiusan.htseasky.com:9001/prod-api${item.coverImage}`"
                alt="商品图片"
              >
            </swiper-slide>
          </swiper> -->
          </div>
        </div>
      </div>
      <!-- 地方组织动态 -->
      <div class="placeDynamic">
        <div class="title">
          <p>地方组织动态</p>
          <span class="zhuanlan_more" @click="toPlaceMore">更多></span>
        </div>
        <div class="citylist">
          <div class="citybox" :class="{ active: item.includes(mapName) }" @click="mapMove(item)" v-for="(item, index) in [
            '九三学社西安市委员会',
            '九三学社宝鸡市委员会',
            '九三学社咸阳市委员会',
            '九三学社汉中市委员会',
            '九三学社渭南市委员会',
            '九三学社榆林市委员会',
            '九三学社杨凌区工委',
          ]" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="content">
          <div class="item_left">
            <!-- 地图 -->
            <!-- <div style="width: 400px; height: 490px;margin-bottom: 15px;" ref="aaa"></div> -->
            <!-- <div v-for="(item, index) in leftDifangList" :key="index">
            <p @click="mapMove(item)">{{ item }}</p>
          </div> -->
            <!-- ------------------- -->
            <el-menu default-active="0" class="el-menu-vertical-demo">
              <el-menu-item style="justify-content: center;margin-bottom: 10px;font-size:15px"
                v-for="(item, index) in leftDifangList" @click="mapMove(item)" :index="index.toString()" :key="index">
                <span slot="title">{{ item }}</span>
              </el-menu-item>
            </el-menu>

          </div>
          <div class="item_right" v-if="placeIsTrue">
            <div class="item" v-for="item in placeList" :key="item.id" @click="toplaceDetail(item.id)">
              <div class="sname">{{ item.jsNavName.substr(0, 2) }}</div>
              <div class="desc">{{ item.title }}</div>
              <!-- <div class="date">{{ item.releaseTime }}</div> -->
            </div>
          </div>
          <div v-else class="nodata" style="
            width: 70%;
            height: 500px;
            text-align: center;
            line-height: 450px;
            color: #ccc;
            font-size: 30px;
            letter-spacing: 3px;
          ">
            暂无数据
          </div>
        </div>
      </div>
      <!-- 大事记和社内互动 -->
      <div class="zhuanti">
        <!-- 大事记 -->
        <div class="dashiji dsj" style="width: 100%;">
          <div class="title">
            <p>大事记</p>
            <span class="zhuanlan_more" @click="toBigMore" style="line-height:30px">更多></span>
          </div>
          <div class="content list">
            <div class="tabContainer swiper-container">

              <ul v-for="item in dsjList" :key="item.id" class="active lcss1 swiper">
                <div style="display: flex" @click="gotoDetail(item.id)">
                  <li class="li001">
                    <a class="head_title">{{ item.title }}</a>
                  </li>
                  <li class="li-time" style="color: #8c8c8c">
                    {{ item.addTime }}
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <!-- <div class="content">
          <div class="item zhuanlan_more" v-for="(item, index) in yearList.slice(0, 12)" :key="index"
            @click="gotoYearDetail(item)">
            {{ item }}年
          </div>
        </div> -->
          <ul class="timeline-wrapper">
            <li class="timeline-item" v-for="(item, yearIndex) in timelineList" :key="yearIndex">
              <div class="timeline-box">
                <div class="out-circle">
                  <div class="in-circle"></div>
                  <div class="timeline-date">
                    <el-button type="text" slot="reference" class="father-text">
                      {{ item }}
                    </el-button>
                    <div class="sub-item-box"
                      :class="`${yearIndex % 2 === 0 ? 'top-sub-item-box' : 'bottom-sub-item-box'}`">
                      <!-- <span>{{ subItem.name + ":" + subItem.num }}人</span> -->
                      <div :class="`sub-line-box ${yearIndex % 2 === 0 ? 'top-line-box' : 'bottom-line-box'}`">
                        <div :class="`children-line-box ${yearIndex % 2 === 0 ? 'top-line' : 'bottom-line'}`"></div>
                        <div :class="`children-box ${yearIndex % 2 === 0 ? 'top-children-box' : 'bottom-children-box'}`"
                          @click="gotoYearDetail(item)">{{ childrenList[item] && childrenList[item].title }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="long-line" style="width:95px">
                </div>
              </div>
            </li>
          </ul>

        </div>
        <!-- 社内互动 -->
        <div class="dashiji sq" v-if="false">
          <div class="title">
            <p>社内互动</p>
          </div>
          <div class="sheneihudong">
            <!-- <div class="item" v-for="item in sheneiList" :key="item.id">
            <i v-if="item.navName === '互动空间'" style="color: #4ea484" class="el-icon-chat-dot-round"></i>
            <i v-if="item.navName === '学习培训'" style="color: #f1c375" class="el-icon-data-analysis"></i>
            <i v-if="item.navName === '社员投稿'" style="color: #bb6056" class="el-icon-reading"></i>
            <i v-if="item.navName === '社内监督'" style="color: #8e44c2" class="el-icon-mobile"></i>
            <p>{{ item.navName }}</p>
          </div> -->
            <div class="item" @click="gotoSYTG">
              <i style="color: #f1c375" class="el-icon-reading"></i>
              <p>
                <span>社员投稿</span>
              </p>
            </div>
            <div class="item" @click="gotoYZJY">
              <i style="color: #4ea484" class="el-icon-chat-dot-round"></i>
              <p>
                <span>议政建言</span>
              </p>
            </div>
            <div class="item" @click="gotoRSSQ">
              <i style="color: #bb6056" class="el-icon-edit-outline"></i>
              <p>
                <span>入社申请</span>
              </p>
            </div>
            <div class="item" @click="gotoSnjd">
              <i style="color: #8e44c2" class="el-icon-mobile"></i>
              <p>社内监督</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 精彩照片 -->
      <div class="jingcaizhaopian" v-if="false">
        <div class="title">
          <p>精彩照片</p>
          <span class="zhuanlan_more" @click="gotoPicList">更多></span>
        </div>
        <!-- 轮播组件 -->
        <!-- <div class="picscroll swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in picList"
            :key="index"
          >
            <img
              class="showImg"
              :src="
                item.articleImg.startsWith('/profile')
                  ? `https://jiusan.htseasky.com:9001/prod-api${item.articleImg}`
                  : `https://jiusan.htseasky.com:9001/prod-api/profile/${item.articleImg}`
              "
              @click="gotoOtherDetail(item.id)"
              alt="暂无图片"
            />
          </div>
        </div>
      </div> -->
        <!-- 【图说历史】 -->
        <div class="st-box swiper-containe">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in picList" :key="index">
              <a href="/m/site/content.do?id=247382" target="_blank">
                <img :src="item.articleImg.startsWith('/profile')
                  ? `http://www.shx93.gov.cn/prod-api${item.articleImg}`
                  : `http://www.shx93.gov.cn/prod-api/profile/${item.articleImg}`
                  " class="main-img" /></a>
            </div>
          </div>
        </div>
        <div class="pic_content">
          <div class="pic_left" v-if="picList.length > 0" @click="gotoFirstDetail">
            <div class="pic_smallTitle">{{ picList[0].title }}</div>
            <img :src="'http://www.shx93.gov.cn/prod-api' + picList[0].articleImg" alt="" />
          </div>
          <!-- 右边小图 -->
          <div class="right">
            <div class="pic_right" v-for="item in picList.slice(1, 7)" :key="item.id" @click="gotoOtherDetail(item.id)">
              <img style="display: block" :src="'http://www.shx93.gov.cn/prod-api' + item.articleImg" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- 专委会、社员风采 -->
      <!-- <div class="membership">
      专委会
      <div class="committee">
        <div class="title">
          <p>专委会</p>
          <span class="zhuanlan_more" @click="zwhMore">更多></span>
        </div>
        <div class="content">
          <div class="tabContainer">
            <ul v-for="item in committeeList" :key="item.id" class="active" style="
                display: flex;
                justify-content: space-between;
                padding: 0px 10px 10px 10px;
              ">
              <div style="display: flex" @click="gotoDetail(item.id)">
                <li style="width: 400px">
                  <a class="head_title">{{ item.title }}</a>
                </li>
                <li style="color: #8c8c8c">
                  {{ item.addTime }}
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
      社员风采
      <div class="sheyuan-style">
        <div class="title">
          <p>社员风采</p>
          <span class="zhuanlan_more" @click="syfcMore">更多></span>
        </div>
        <div class="content">
          <div class="tabContainer">
            <ul v-for="item in sheyuanList" :key="item.id" class="active"
              style="display: flex;justify-content: space-between;padding: 0px 10px 10px 10px;">
              <div style="display: flex" @click="gotoDetail(item.id)">
                <li style="width: 400px">
                  <a class="head_title">{{ item.title }}</a>
                </li>
                <li style="color: #8c8c8c">
                  {{ item.addTime }}
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div> -->

      <!-- 友情链接 -->
      <div class="bottomLink">
        <el-tabs v-model="activeName">
          <el-tab-pane label="社内组织" name="first">
            <div class="content">
              <a target="_blank" title="社中央" href="http://www.93.gov.cn/">社中央</a>
              <a target="_blank" title="北京市" href="http://www.bj93.gov.cn/">北京市</a>
              <a target="_blank" title="天津市" href="http://www.tj93.gov.cn/">天津市</a>
              <a target="_blank" title="河北省" href="http://www.93.he.cn/">河北省</a>
              <!--<a target="_blank" title="山西省" href="http://www.sx93.gov.cn/">山西省</a>-->
              <a target="_blank" title="内蒙古" href="http://www.93nmg.gov.cn/">内蒙古</a>
              <!--<a target="_blank" title="辽宁省" href="http://www.ln93.gov.cn/">辽宁省</a>-->
              <a target="_blank" title="吉林省" href="http://www.jl93.gov.cn/">吉林省</a>
              <a target="_blank" title="黑龙江" href="http://www.hlj93.gov.cn/">黑龙江</a>
              <a target="_blank" title="上海市" href="http://www.sh93.gov.cn/">上海市</a>
              <a target="_blank" title="江苏省" href="http://www.js93.gov.cn">江苏省</a>
              <a target="_blank" title="浙江省" href="http://www.zjjs.org/">浙江省</a>
              <a target="_blank" title="安徽省" href="http://www.ah93.gov.cn/">安徽省</a>
              <a target="_blank" title="福建省" href="http://www.fj93.gov.cn/">福建省</a>
              <a target="_blank" title="江西省" href="http://www.93jx.org/">江西省</a>
              <a target="_blank" title="山东省" href="http://www.sd93.gov.cn/">山东省</a>
              <a target="_blank" title="河南省" href="http://www.hns93.gov.cn">河南省</a>
              <a target="_blank" title="湖北省" href="http://www.hb93.gov.cn/">湖北省</a>
              <a target="_blank" title="湖南省" href="http://www.hn93.gov.cn/">湖南省</a>
              <a target="_blank" title="广东省" href="http://www.93.gd.cn/">广东省</a>
              <a target="_blank" title="广西区" href="http://www.gx93.gov.cn/">广西区</a>
              <a target="_blank" title="海南省" href="http://www.hn93.org.cn/">海南省</a>
              <a target="_blank" title="重庆市" href="https://www.cq93.gov.cn/">重庆市</a>
              <a target="_blank" title="四川省" href="https://www.93sc.gov.cn">四川省</a>
              <a target="_blank" title="贵州省" href="http://www.gz93.gov.cn/">贵州省</a>
              <a target="_blank" title="云南省" href="http://www.93yn.org/">云南省</a>
              <!-- <a target="_blank" title="陕西省" href="http://www.shx93.gov.cn/">陕西省</a> -->
              <a target="_blank" title="甘肃省" href="http://gs93.gov.cn/index.html">甘肃省</a>
              <a target="_blank" title="青海省" href="http://qh93.gov.cn">青海省</a>
              <!--<a target="_blank" title="宁夏区" href="http://www.nx93.gov.cn/">宁夏区</a>-->
              <a target="_blank" title="新疆区" href="http://www.93xj.org.cn/">新疆区</a>
            </div>
          </el-tab-pane>
          <el-tab-pane label="友情链接" name="second">
            <div class="content">
              <a target="_blank" title="陕西省人民政府" href="http://www.shaanxi.gov.cn/">陕西省人民政府</a>
              <a target="_blank" title="陕西省人民代表大会" href="http://sxrd.gov.cn/">陕西省人民代表大会</a>
              <a target="_blank" title="中国人民政治协商会议陕西委员会" href="http://www.sxzx.gov.cn/">中国人民政治协商会议陕西委员会</a>
              <a target="_blank" title="中共陕西省委统一战线工作部" href="http://www.zgsxswtzb.gov.cn/">中共陕西省委统一战线工作部</a>
              <a target="_blank" title="中国国民党革命陕西省委员会" href="http://www.sxmgwyh.cn/">中国国民党革命陕西省委员会</a>
              <a target="_blank" title="中国民主同盟陕西省委员会" href="http://www.mmsxsw.org.cn/">中国民主同盟陕西省委员会</a>
              <a target="_blank" title="中国民主建国会陕西省委员会" href="http://www.mjsx.org.cn/">中国民主建国会陕西省委员会</a>
              <a target="_blank" title="中国民主促进会陕西省委员会" href="http://www.sshanximj.org.cn/">中国民主促进会陕西省委员会</a>
              <a target="_blank" title="中国农工民主党陕西省委员会" href="http://www.ngdsxswyh.gov.cn/">中国农工民主党陕西省委员会</a>
              <a target="_blank" title="中国致公党陕西省委员会" href="http://www.shxzg.org.cn/">中国致公党陕西省委员会</a>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </transition>
</template>
<script>
// import * as echarts from "echarts";
// import getShanXiMap from '../../common/api/getShanXiMap'
// import getShanXiMap from "@/assets/shanxi.json";
import Carousel from "./Carousel.vue";
import "swiper/css/swiper.min.css";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { isMobile } from "@/utils/common.js";
export default {
  name: "courseType",
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide,
    Carousel
  },
  data() {
    return {
      leftDifangList: [
        '九三学社西安市委员会',
        '九三学社宝鸡市委员会',
        '九三学社咸阳市委员会',
        '九三学社汉中市委员会',
        '九三学社渭南市委员会',
        '九三学社榆林市委员会',
        '九三学社杨凌区工委'
      ],
      activeName: 'first',
      // 专题菜单列表
      subjectList: [],
      // allSubjectList: [],
      // secondSubjectList: [],
      // 文章列表
      articleList: [],
      arr2: [],
      allArr2: [],
      nlist: "",
      allNewsArr: "",
      allArr: [],

      one: [],
      two: [],
      three: [],
      four: [],
      five: [],
      six: [],
      seven: [],
      eight: [],
      nine: [],
      ten: [],

      boxList: [],
      // 电子期刊列表
      EBookList: [],

      placeList: [],
      placeIsTrue: true,
      picList: [],

      mapName: "九三学社西安市委员会",
      yearList: [], //大事记
      committeeList: [], //专委会
      sheyuanList: [], // 社员风采
      sheneiList: [], //社内互动

      // 链接
      options: [
        {
          value: "www.siwonet.com",
          label: "西安思沃",
        },
      ],
      value: "",
      one_arr: [],
      all_one_arr: [],

      dsjList: [],
      // 专题专栏图片
      ztzlBannerPic: '',
      timelineList: [],
      childrenList: {}
    };
  },
  created() {
    // 获取专委会
    this.getCommittee();
    // 获取社员风采
    this.getSheyuan();
    // 获取专题菜单列表
    this.getSubjectInfo();
    // 获取大事件年份列表
    this.getYear();
    // 获取社内互动列表
    // this.getShenei();
    // 一进页面默认加载一遍
    this.mapMove("西安市");
    // 获取精彩照片
    // this.getPic();
    // 获取第一个菜单的新闻列表，是后两个菜单列表之和，一进页面默认加载
    this.firstMenu();
    // 获取电子期刊列表
    this.getEBookList();
    // 获取大事件
    this.getDsjList();
    // 获取顶部图片和专题专栏图片
    this.getBannerPic()
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    swiperOption() {
      return {
        speed: 500,
        effect: isMobile() ? 'slide' : 'slide',
        centeredSlides: false,
        spaceBetween: '4%',
        slidesPerView: isMobile() ? '1' : '4',
        loop: false,
        touchRatio: 2,
        autoplay: true,

        // coverflowEffect: {
        //   rotate: 30,
        //   stretch: 0,
        //   depth: 60,
        //   modifier: 2,
        //   slideShadows: false,
        // },
      }
    },
  },
  methods: {
    scrollEvent(e) {
      this.$emit("scrollEvent", e);
    },
    handleBottomClick() {
      this.$emit("handleBottomClick");
    },
    // 获取专题专栏图片
    async getBannerPic() {
      let res = await this.$api.nav.getBannerPic(3);
      // console.log('picpcipicpic',res.data.rows[0].mediaPath);
      this.ztzlBannerPic = res.data.rows[0] && res.data.rows[0].mediaPath

      let res_top = await this.$api.nav.getBannerPic(1);
      // console.log('toppic-toppic-toppic', res_top);
      this.topBannerPic = res_top.data.rows
    },
    // 议政建言跳转
    gotoYZJY() {
      window.open('http://61.185.253.210:8080/edc/formview/j93084', '_blank');
    },
    // 社员投稿跳转
    gotoSYTG() {
      window.open('http://61.185.253.210:8080/edc/formview/zr10e7', '_blank')
    },
    // 入社申请跳转
    gotoRSSQ() {
      window.open('http://61.185.253.210:8080/edc/formview/y20j7f', '_blank')
    },
    // 社内监督跳转
    gotoSnjd() {
      this.$router.push(`/Snjd`)
    },
    // 电子期刊点击更多跳转
    toEBookMore() {
      this.$router.push(`/newsSecondDetail?navName=电子期刊`)
      // this.$router.push({
      //   name: "routeSecond",
      //   params: { navName: "电子期刊" },
      // });
    },
    // 获取电子期刊列表
    async getEBookList() {
      let res = await this.$api.nav.getEBook();
      this.EBookList = res.data.rows.splice(0, 4)
      // console.log('EBookList', this.EBookList);
    },
    ljwyhMore() {
      this.$router.push(`/newsList?title=专题专栏`)
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { title: "社委组成成员" },
      // });
    },
    // 研究院及基地、陕西九三学社科研产业合作座谈会、陕西九三学社医疗服务团栏目跳转
    async columnMore(id, name) {
      // this.$router.push(`/newsList?zwhName=专委会及工作机构`)tm=${self.id}&navName=${self.navName}`
      this.$router.push(`/selfConstructionList?tm=${id}&navName=${name}&name=${name}`)
      // this.$router.push(`/newsSecondDetail?navName=专委会及工作机构`)

      // this.$router.push({
      //   name: "routeSecond",
      //   params: { navName: "专委会" },
      // });
    },
    // 专委会点击更多
    async zwhMore() {
      // this.$router.push(`/newsList?zwhNam e=专委会及工作机构`)tm=${self.id}&navName=${self.navName}`
      this.$router.push(`/selfConstructionList?tm=1154148208348233728&navName=专委会&name=专委会`)
      // this.$router.push(`/newsSecondDetail?navName=专委会及工作机构`)

      // this.$router.push({
      //   name: "routeSecond",
      //   params: { navName: "专委会" },
      // });
    },
    // 历史回眸点击更多
    syfcMore() {
      this.$router.push(`/newsList?title=历史回眸`)
      // this.$router.push({
      //   name: "routeSecond",
      //   params: { navName: "社员风采" },
      // });
    },
    // 获取专委会
    async getCommittee() {
      // console.log("-------专委会--------");
      let res = await this.$api.nav.getCommittee("专委会", 3);
      // console.log(res.data.data[0].id);
      let res1 = await this.$api.nav.getArticle(res.data.data[0].id);
      this.committeeList = res1.data.rows.splice(0, 6);
      // console.log('专委会', this.committeeList);
    },
    async getSheyuan() {
      // console.log("-------历史回眸--------");
      // let res = await this.$api.nav.getCommittee("社员风采", 3);
      let res2 = await this.$api.nav.specialGetArticle(
        1,
        100,
        1,
        '历史回眸'
      )

      // let res2 = await this.$api.nav.getArticle(
      //   '1146098982141820928',
      //   1,
      //   6,
      //   1,
      //   this.$route.query.keyVal,
      //   this.$route.query.year
      // );
      // console.log("22222222222222222222", res2);
      this.newsList = res2.data.rows;
      this.total = res2.data.total;

      // let res1 = await this.$api.nav.getArticle(res.data.data[0].id);
      this.sheyuanList = res2.data.rows;
      // console.log("sheyuanList", this.sheyuanList);
    },
    // 地方动态跳转更多
    toPlaceMore() {
      this.$router.push(`/newsList?placeName=地方动态`);
    },
    // 地方动态新闻列表跳转
    async toplaceDetail(_id) {
      // console.log("_placeId", _id);
      this.$router.push(`/newsDetail?tm=${_id}`);
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { id: _id },
      // });
    },
    // 大事记跳转更多
    toBigMore() {
      this.$router.push(`/newsList?placeName=大事记`);
    },
    // 跳转至更多
    // 菜单栏点击跳转
    czyz_toMore(showId, navName) {
      // console.log("_id", _id, navName);
      // 路由跳转
      this.$router.push(`/selfConstruction?tm=1173669541671075840&name=参政议政`);
      // this.$router.push({name:'routeNewsList',params:{id:_id,name:navName}})
    },
    // 社会服务点击更多
    shfw_toMore() {
      this.$router.push(`/selfConstruction?tm=1146098603371003904&name=社会服务`);
    },
    // 思想 组织 机关建设点击更多
    sx_zz_jg_toMore(id, name) {
      // this.$router.push(`/newsSecondDetail?tm=${id}&navName=${name}`);
      this.$router.push(`/selfConstruction?tm=1146097762320777216&name=自身建设&isSingle=true&navName=${name}`);
    },
    // 跳转至详情
    gotoDetail(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`);
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { tm: _id },
      // });
    },
    // 跳转至列表
    gotoList() {
      this.$router.push(`/newsDetail?tm=${_id}`);
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { id:_id },
      // });
    },
    // 获取第一个菜单的新闻列表，是后两个菜单列表之和
    async firstMenu() {
      // const promises = [
      //   this.$api.nav.getArticle('1173669784244453376'),
      //   this.$api.nav.getArticle('1173669815873699840'),
      //   this.$api.nav.getArticle('1146098033667080192'),
      //   this.$api.nav.getArticle('1151091253635448832'),
      //   this.$api.nav.getArticle('1146098315738218496'),
      // ]
      // const responses = await Promise.all(promises)
      // this.boxList = responses.map(item => item.data.rows)
      // console.log('boxList', this.boxList);

      let res1 = await this.$api.nav.getSpecialColumn('1173669541671075840');
      this.one = res1.data.data

      // let res2 = await this.$api.nav.getArticle(
      //   '1173669815873699840', 1, 6
      // );
      let res2 = await this.$api.nav.getSpecialColumn('1146098603371003904')

      this.two = res2.data.data

      let res3 = await this.$api.nav.getSpecialColumn('1146098033667080192')

      // let res3 = await this.$api.nav.getArticle(
      //   '1146098033667080192', 1, 6
      // );
      this.three = res3.data.data

      let res4 = await this.$api.nav.getSpecialColumn('1151091253635448832')

      // let res4 = await this.$api.nav.getArticle(
      //   '1151091253635448832', 1, 6
      // );
      this.four = res4.data.data

      let res5 = await this.$api.nav.getSpecialColumn('1146098315738218496')

      // let res5 = await this.$api.nav.getArticle(
      //   '1146098315738218496', 1, 6
      // );
      this.five = res5.data.data

      let res6 = await this.$api.nav.getArticle1('1306946679664017408', 1, 10, 1, '陕西九三学社医疗服务团')
      this.six = res6.data.rows

      let res7 = await this.$api.nav.getArticle1('1306946600525889536', 1, 10, 1, '陕西九三学社科研产业合作座谈会')
      this.seven = res7.data.rows

      let res8 = await this.$api.nav.getArticle1('1308104488640315392', 1, 10, 1, '陕西九三学社碳中和研究院')
      this.eight = res8.data.rows

      let res9 = await this.$api.nav.getArticle1('1308104428946980864', 1, 10, 1, '陕西九三学社乡村振兴研究院')
      this.nine = res9.data.rows

      let res10 = await this.$api.nav.getArticle1('1306946543533686784', 1, 10, 1, '九三学社稻地江村乡村振兴融合实践基地')
      this.ten = res10.data.rows

      console.log('res10', res10);



      // ---------------------------------------------------------
      //   // 科教服务 社会建设
      //   let res1 = await this.$api.nav.getArticle("1139885753573048320");
      //   let res2 = await this.$api.nav.getArticle("1139885833579397120");
      //   this.one.push(res1.data.rows);
      //   this.one.push(res2.data.rows);
      //   // this.one.push(one1.flat(Infinity))
      //   this.one = this.one.flat(Infinity);
      //   // console.log("one", this.one);

      //   // 议政建言 专题调研
      //   let res3 = await this.$api.nav.getArticle("1146102713776340992");
      //   let res4 = await this.$api.nav.getArticle("1146102793669443584");
      //   // console.log(res3);
      //   this.two.push(res3.data.rows);
      //   this.two.push(res4.data.rows);
      //   this.two = this.two.flat(Infinity);

      //   // 组工通讯 基层连线
      //   let res5 = await this.$api.nav.getArticle("1146103361825669120");
      //   let res6 = await this.$api.nav.getArticle("1146103455513837568");
      //   this.three.push(res5.data.rows);
      //   this.three.push(res6.data.rows);
      //   this.three = this.three.flat(Infinity);

      //   // 机关工作 制度建设
      //   let res7 = await this.$api.nav.getArticle("1146103684564779008");
      //   let res8 = await this.$api.nav.getArticle("1146103736037277696");
      //   this.four.push(res7.data.rows);
      //   this.four.push(res8.data.rows);
      //   this.four = this.four.flat(Infinity);

      //   // 学习动态 理论研究
      //   let res9 = await this.$api.nav.getArticle("1151093987390521344");
      //   let res10 = await this.$api.nav.getArticle("1151094036900085760");
      //   this.five.push(res9.data.rows);
      //   this.five.push(res10.data.rows);
      //   this.five = this.five.flat(Infinity);
    },
    // 获取专题菜单列表
    async getSubjectInfo() {
      // 导航栏获取一级菜单
      let first_nav_res = await this.$api.nav.getNavList(1, 0);
      // console.log('导航栏的一级菜单', first_nav_res);
      // this.one = res.data.data[2]
      // console.log('one',this.one);

      // // 导航栏获取二级菜单
      // let second_res = await this.$api.nav.getNavList(1, this.one.id);
      // console.log('参政议政的二级',second_res.data.data);


      let res = await this.$api.nav.getSpecial();
      this.subjectList = res.data.data;
      // console.log('专题菜单', this.subjectList);
      // 整合专题菜单列表--------------------------------
      let arr = [];
      let allArr = [];
      let obj = {};
      let obj2 = {};
      this.subjectList.map((item) => {
        arr = [];
        obj = {};
        obj.navName = item.navName;
        obj.id = item.id;
        obj.isShow = item.isShow;
        arr.push(obj);
        item.jsSiteNavVOList.map((subItem) => {
          obj2 = {};
          obj2.navName = subItem.navName;
          obj2.id = subItem.id;
          obj2.isShow = subItem.isShow;
          // 这里可以获取到id，用来查询对应的文章列表
          // console.log(subItem.id)
          arr.push(obj2);
        });
        allArr.push(arr);
      });
      // console.log("1111111111111", allArr);
      this.allArr = allArr;

      // // this.one = [{title:'123',addTime:'1111'}]
    },
    // 鼠标移入菜单栏
    async tabBoxEnter(name, id, index, isShow) {
      // if(index === 0){
      //   this.one = [];
      //   this.two = [];
      //   this.three = [];
      //   this.four = [];
      //   this.five = [];
      //   this.firstMenu()
      // }
      // if (id === "1139885753573048320" || id === "1139885833579397120") {
      //   this.one = [];
      // }
      // if (id === "1146102713776340992" || id === "1146102793669443584") {
      //   this.two = [];
      // }
      // if (id === "1146103361825669120" || id === "1146103455513837568") {
      //   this.three = [];
      // }
      // if (id === "1146103684564779008" || id === "1146103736037277696") {
      //   this.four = [];
      // }
      // if (id === "1151093987390521344" || id === "1151094036900085760") {
      //   this.five = [];
      // }

      // console.log(name, id, index, isShow);
      // // 样式的激活与取消
      // if (isShow === 1) {
      //   this.allArr.map((item) => {
      //     item.map((subItem) => {
      //       if (subItem.id === id) {
      //         // 修改为 0，即鼠标移入激活 active 样式
      //         subItem.isShow = 0;
      //       }
      //     });
      //   });
      // }
      // // 根据菜单id，获取当前专栏对应的文章
      // let res = await this.$api.nav.getArticle(id, 1, 100, 1);
      // // console.log(res);
      // if (id === "1139885753573048320" || id === "1139885833579397120") {
      //   console.log("resss", res);
      //   res.data.rows.map((item) => {
      //     // console.log(item);
      //     this.one.push(item);
      //   });
      // }
      // if (id === "1146102713776340992" || id === "1146102793669443584") {
      //   res.data.rows.map((item) => {
      //     this.two.push(item);
      //   });
      // }
      // if (id === "1146103361825669120" || id === "1146103455513837568") {
      //   res.data.rows.map((item) => {
      //     this.three.push(item);
      //   });
      // }
      // if (id === "1146103684564779008" || id === "1146103736037277696") {
      //   res.data.rows.map((item) => {
      //     this.four.push(item);
      //   });
      // }
      // if (id === "1151093987390521344" || id === "1151094036900085760") {
      //   res.data.rows.map((item) => {
      //     this.five.push(item);
      //   });
      // }

      // // console.log("one", this.one);
      // // console.log('res', res.data.rows);
      // // this.articleList = res.data.rows
    },
    // 鼠标移出菜单栏
    tabBoxLeave(id, index, isShow) {
      // if (isShow === 0) {
      //   this.allSubjectList.map(item => {
      //     item.map(subItem => {
      //       if (subItem.id === id) {
      //         // 修改为 1，即鼠标移出取消 active 样式
      //         subItem.isShow = 1
      //       }
      //     })
      //   })
      // }
    },
    // 跳转大事记年份详情
    gotoYearDetail(year) {
      // console.log('year', year);
      this.$router.push(`/newsSecondDetail?year=${year}&navName=大事记`)
      // this.$router.push({
      //   name: "routeSecond",
      //   params: { year: year, navName: "大事记" },
      // });
    },
    // 精彩照片第一张大图跳转至详情
    gotoFirstDetail() {
      this.$router.push(`/newsDetail?tm=${this.picList[0].id}`)
      // this.$router.push({
      //   name: "routeNewsDetail",
      //   params: { id: this.picList[0].id },
      // });
    },
    // 精彩照片其余照片跳转至详情
    gotoOtherDetail(_id) {
      this.$router.push(`/newsDetail?tm=${_id}`)
      // this.$router.push({ name: "routeNewsDetail", params: { id: _id } });
    },
    gotoPicList() {
      this.$router.push(`/picList`)
      // this.$router.push({ name: "routePicList" });
    },
    // 获取精彩照片
    async getPic() {
      let res = await this.$api.nav.getPic("精彩照片");
      this.picList = res.data.rows;
      // console.log('精彩照片', res);

      this.$nextTick(function () {
        // new Swiper(".swiper-container", {
        //   freeMode: true,
        //   spaceBetween: 10,
        //   loop: true,
        //   roundLengths: true,
        //   initialSlide: 1,
        //   speed: 3000,
        //   slidesPerView: 3,
        //   centeredSlides: true,
        //   followFinger: false,
        //   autoplay: {
        //     delay: 10,
        //     disableOnInteraction: false, //就算触摸了也继续滚动
        //   },
        //   direction: "horizontal",
        // });
        new Swiper(".st-box", {
          roundLengths: true,
          initialSlide: 1,
          speed: 600,
          slidesPerView: "auto",
          centeredSlides: true,
          followFinger: false,
          //  freeMode: true,
          loop: true,
          autoplay: {
            disableOnInteraction: false,
            delay: 7000, //3秒切换一次
          },
          direction: "horizontal",
        });
      });
      // new Swiper(".swiper-container", {
      //   //是否循环播放
      //   loop: true,
      //   autoplay: {
      //     disableOnInteraction: false,
      //     delay: 3000, //3秒切换一次
      //   },
      //   //滑动方向
      //   direction: "horizontal",
      // });
    },
    // 获取社内互动列表
    async getShenei() {
      let res = await this.$api.nav.getshenei("社内互动");
      this.sheneiList = res.data.data;
      let res111 = await this.$api.nav.getshenei("社内监督");
      // console.log('社内监督-----------', res111);
    },
    async getDsjList() {
      let res = await this.$api.nav.getArticle(
        null,
        1,
        10,
        1,
        null,
        null,
        "大事记"
      );
      this.dsjList = res.data.rows;
      // console.log(" this.dsjList ", this.dsjList);
    },
    // 获取大事件年份列表
    async getYear() {
      let res = await this.$api.nav.getYear();
      this.yearList = res.data.rows;
      // console.log('yearList', this.yearList);
      this.timelineList = res.data.rows.splice(0, 10).reverse();
      this.timelineList.forEach(async item => {
        await this.getArticle(item);
      })
    },
    async getArticle(year) {
      const { data, status } = await this.$api.nav.getArticle(null, 1, 10, 1, '', year, '大事记');
      if (status !== 200) return;
      this.$set(this.childrenList, year, data.rows.length && data.rows[0])
    },
    // 鼠标移入移出地图，获取对应的地方动态
    async mapMove(arg) {
      if (arg == '九三学社西安市委员会') {
        this.mapName = '西安市'
      } else if (arg == '九三学社咸阳市委员会') {
        this.mapName = '咸阳市'
      } else if (arg == '九三学社宝鸡市委员会') {
        this.mapName = '宝鸡市'
      } else if (arg == '九三学社渭南市委员会') {
        this.mapName = '渭南市'
      } else if (arg == '九三学社汉中市委员会') {
        this.mapName = '汉中市'
      } else if (arg == '九三学社榆林市委员会') {
        this.mapName = '榆林市'
      } else if (arg == '九三学社杨凌区工委') {
        this.mapName = '杨凌区'
      } else {
        this.mapName = '西安市'
      }
      // this.mapName = arg;
      // console.log('this.mapName', this.mapName);
      let res = await this.$api.nav.getPlace(this.mapName);
      // console.log(res.data.rows);
      this.placeList = res.data.rows;
      if (res.data.rows.length > 0) {
        this.placeIsTrue = true;
      } else {
        this.placeIsTrue = false;
      }
    },
  },
  // mounted() {
  //   let that = this;
  //   // 初始化统计图对象
  //   var myChart = echarts.init(this.$refs["aaa"]);
  //   // 获取移入的每一个省份的配置信息
  //   myChart.on("mouseover", function (params) {
  //     console.log(params);
  //     that.mapMove(params.name);
  //   });
  //   // 显示 loading 动画
  //   myChart.showLoading();
  //   // 再得到数据的基础上，进行地图绘制
  //   // getShanXiMap.then((res) => {
  //   // 得到结果后，关闭动画
  //   myChart.hideLoading();
  //   // 注册地图，数据放在axios返回对象的data中
  //   echarts.registerMap("SX", getShanXiMap);

  //   var option = {
  //     series: [
  //       {
  //         name: "陕西地图",
  //         type: "map",
  //         map: "SX", // 这是上面注册时的名字
  //         label: {
  //           show: true,
  //           // 地图上显示的文字颜色
  //           color: "#0A4788",
  //         },
  //         // 重点，更改地图的颜色和当前激活部分的颜色
  //         itemStyle: {
  //           // 正常预览的状态下，更改背景色和边框线颜色
  //           normal: {
  //             areaColor: "#D9EBFE",
  //             borderColor: "#FFFFFF",
  //           },
  //           // 选中的状态下，更改背景色
  //           emphasis: {
  //             areaColor: "#75B6F6",
  //             label: {
  //               show: true,
  //               color: "#fff",
  //             },
  //           },
  //         },
  //         // 鼠标点击后
  //         select: {
  //           // 标签文本的样式设置
  //           label: {
  //             show: true,
  //             color: "#fff",
  //           },
  //           // 地图区域的样式设置
  //           itemStyle: {
  //             // 被点击后的背景颜色
  //             areaColor: "#75B6F6",
  //           },
  //         },
  //       },
  //     ],
  //   };
  //   myChart.setOption(option);
  //   // });
  // },
};
</script>


<style lang="scss" scoped>
.ebook-item {
  margin-left: 15px;

  &:hover {
    cursor: pointer;
  }
}

// ----------- 底部友情链接 ↓ ---------------
.bottomLink {
  width: 1200px;
  margin: auto;
  padding-bottom: 20px;
  margin-top: 20px;

  .content {
    margin-left: 15px;
    display: flex;
    flex-wrap: wrap;

    a {
      display: block;
      // background-color: pink;
      padding: 10px;
      margin-right: 10px;
      transition: all .2s linear;

      &:hover {
        color: #3282D2;
      }
    }
  }
}

::v-deep .el-tabs__item.is-active {
  color: #3282D2;
  font-size: 20px;
}

::v-deep .el-tabs__item {
  color: #323232;
  font-size: 20px;
}

::v-deep .el-tabs__active-bar {
  background-color: #3282D2;
  height: 1px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #D5D5D5;
}

// ----------- 底部友情链接 ↑ ---------------
.zhuanlan_more {
  line-height: 50px;
  cursor: pointer;
}

.head_title {
  background-image: "";
  color: #323232;
  line-height: 30px;
  display: block;
  font-size: 16px;
  position: relative;
  padding-left: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.head_title:before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  // background-color: #1D4D8A;
  border: 3px solid #1e74cd;
  // border-top: 4px solid transparent;
  // border-bottom: 4px solid transparent;
  // border-left: 4px solid #323232;
  position: absolute;
  top: 50%;
  left: 25px;
  transform: translateY(-50%);
  transition: 0.3s;
}

.jingcaizhaopian {
  width: 1200px;
  margin: auto;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 5px #f5f5f5;
  margin-top: 20px;

  .title {
    display: flex;
    justify-content: space-between;

    p {
      font-size: 23px;
      font-weight: bolder;
    }

    span {
      font-size: 18px;
      color: #2861a8;
    }
  }

  .pic_content {
    display: flex;

    .pic_left {
      position: relative;
      overflow: hidden;

      img {
        &:hover {
          cursor: pointer;
        }
      }

      .pic_smallTitle {
        font-size: 13px;
        padding: 5px;
        padding-left: 10px;
        position: absolute;
        bottom: 25px;
        width: 435px;
        color: white;
        background-color: rgba(0, 0, 0, 0.6);
        height: 25px;
        line-height: 30px;
      }

      img {
        width: 450px;
      }

      padding: 20px;
    }

    .right {
      position: relative;
      margin-left: 20px;
      width: 200px;
      display: flex;
      width: 700px;
      flex-wrap: wrap;
      // background-color: pink;
      margin-top: 20px;

      .pic_right {
        padding-bottom: 0px;
        width: 200px;
        height: 140px;
        overflow: hidden;
        margin-right: 20px;

        img {
          display: inline-block;
          width: 200px;
          height: 140px;
          margin-right: 10px;
          transition: all .5s linear;

          &:hover {
            cursor: pointer;
            transform: scale(1.2);
          }
        }
      }
    }
  }

  .title {
    color: #2f2f2f;
    padding: 10px 15px;
    border-bottom: 1px solid #ededed;
    font-size: 23px;
    font-weight: bolder;
    line-height: 50px;
  }
}

// -------------------专委会、社员风采-----大事记和社内互动-----------

// 专委会、社员风采
.membership,
// 大事记和社内互动
.zhuanti {
  // background-color: white;
  display: flex;
  width: 1200px;
  margin: auto;
  // background-color: white;
  margin-top: 25px;
  justify-content: space-between;

  .dsj,
  // 专委会
  .committee,
  // 社员风采
  .sheyuan-style,
  // 社内互动
  .interact,
  // 大事记
  .dashiji {
    background-color: white;
    width: 49%;
    border-radius: 8px;
    box-shadow: 0px 0px 5px 5px #f5f5f5;

    // padding: 0 0 20px;
    .title {
      height: 30px;
    }

    .sheneihudong {
      padding: 40px 30px 0px 30px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .item {
        display: flex;
        padding: 20px;
        margin-bottom: 30px;
        width: 40%;
        border-radius: 8px;
        box-shadow: 0px 0px 5px 5px #f5f5f5;

        &:hover {
          cursor: pointer;
        }

        i {
          font-size: 40px;
        }

        p {
          height: 40px;
          width: 300px;
          line-height: 40px;
          // background-color: pink;
          margin-left: 17px;
          text-align: center;
          font-size: 18px;
          border-left: 1px solid #ebebeb;
        }
      }
    }

    .content:after {
      display: flex;
      justify-content: space-between;
      content: '';
      width: 47%;
    }

    .content {
      // padding: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 10%;
      // width: 580px;
      // height: 230px;
      overflow: hidden;
      line-height: 30px;
      // background-color: pink;
      margin: auto;

      .item {
        color: white;
        text-align: center;
        width: 100px;
        height: 50px;
        font-size: 17px;
        line-height: 50px;
        background-color: #6eaff1;
        border-radius: 8px;
        margin: 7px;
        margin-top: 20px;
      }
    }

    .title {
      color: #2f2f2f;
      padding: 10px 15px;
      border-bottom: 1px solid #ededed;
      display: flex;
      justify-content: space-between;
      height: 3;

      p {
        font-size: 23px;
        font-weight: bolder;
      }

      span {
        font-size: 18px;
        color: #2861a8;
      }
    }
  }
}

.ztzl {
  width: 1200px;
  margin: auto;
  // background-color: white;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 0px 0px 5px 5px #f5f5f5;
  margin-bottom: 30px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #2f2f2f;
    padding: 10px 15px;

    // border-bottom: 2px solid #ccc;
    p {
      font-size: 23px;
      font-weight: bolder;
    }

    span {
      font-size: 18px;
      color: #2861a8;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .content {
    &:hover {
      cursor: pointer;
    }
  }
}

.placeDynamic {
  width: 1200px;
  margin: auto;
  // background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 5px 5px #f5f5f5;

  .content {
    .item_left {
      width: 25%;
      margin-right: 30px;
      text-align: center;
      margin-top: 24px;
    }

    .item_right {
      width: 65%;
      padding-top: 20px;
      padding-bottom: 20px;

      // background-color: skyblue;
      .item {
        // background-color: pink;
        height: 26px;
        line-height: 30px;
        margin-bottom: 10px;
        padding-top: 10px;
        display: flex;
        justify-content: space-between;

        &:hover {
          cursor: pointer;
        }

        .sname {
          background-color: #73b1ec;
          color: white;
          width: 50px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border-radius: 8px;
          font-size: 15px;
          letter-spacing: 3px;
        }

        .desc {
          width: 25%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex: 2;
          margin-left: 10px;
          font-size: 15px;
          color: #323232;
        }

        .date {
          color: #919191;
        }
      }
    }
  }

  .title {
    display: flex;
    justify-content: space-between;
    color: #2f2f2f;
    padding: 10px 15px;
    line-height: 50px;
    border-bottom: 1px solid #ededed;

    p {
      font-size: 23px;
      font-weight: bolder;
    }

    span {
      font-size: 18px;
      color: #2861a8;
    }
  }

  .content {
    display: flex;

    .left {
      background-color: transparent;
    }
  }
}

/* 123 */
.wrap {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

body {
  background: #ffffff;
  overflow-x: hidden;
}

.column-box {
  display: flex;
  // justify-content: space-between;
  flex-wrap: wrap;
}

.news-column {
  .tabNav1 {
    // margin-top: -2px;
    display: flex;
    width: 95%;
    border-bottom: 2px solid #D5D5D5;
  }

  .text {
    height: 54px;
    line-height: 54px;
    margin-bottom: -1px;
    border-bottom: 2px solid #0B7DDA;
    position: relative;

    .title {
      background-color: white;
      color: #0B7DDA;
      font-size: 20px;
    }
  }

  .tabNav {
    border-bottom: 1px solid pink;
  }
}

/*公共样式*/

.indexTab .tabBox .tabNav .txt:nth-child(1) h3 {
  border-radius: 10px 0 0;
  background-color: #0b7dda;
  color: white;
}

.indexTab .tabBox .tabNav .txt .txt:hover {
  cursor: pointer;
}

.indexTab .tabBox .tabNav p {
  cursor: pointer;
}

.indexTab .tabBox .tabNav .txt:nth-child(1) h3 a {
  color: white;
}

.indexTab .tabBox .tabNav .txt:nth-child(3) h3 a {
  color: #767676;
}

.indexTab .tabBox .tabNav .txt h3:hover {
  cursor: pointer;
  background-color: #0b7dda;
  color: white;
}

.txt {
  font-size: 22px;
  // color: #bd1b2d;
  height: 54px;
  line-height: 54px;
  // border-bottom: 1px solid red;
  position: relative;
}

.wrap {
  /* background-color: pink; */
  display: flex;
  flex-wrap: wrap;
}

.wrap .tabBox {
  /* background-color: pink; */
}

.txt h3 {
  min-width: 110px;
  // border-bottom: 1px solid #bd1b2d;
  line-height: 53px;
  text-align: center;
  padding: 0 12px;
  display: inline-block;
  font-size: 20px;
}

.txt h3>a {
  // color: #bd1b2d;
}

.title {
  // border-bottom: 1px solid #bd1b2d;
  position: relative;
  // margin-bottom: 10px;
}

.title h2 {
  font-size: 28px;
  color: #fff;
  height: 60px;
  line-height: 60px;
  width: 180px;
  text-align: center;
}

.title:after {
  content: "";
  /* background: url(../images/title_bg.png) no-repeat center; */
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 204px;
  height: 60px;
  z-index: -1;
}

.left {
  display: flex;
  align-items: center;
  background-color: rgb(245, 245, 245);
}

.right {
  margin-left: 20px;
}

.Item:last-child {
  margin-right: 0;
}

.Item1:last-child {
  margin-right: 0;
}

.Item ul li {
  padding: 8px 0;
}

.Item1 ul li {
  padding: 8px 0;
}

.Item1 ul li {
  padding: 8px 0;
}

.Item1 ul li a {
  color: #323232;
  line-height: 24px;
  display: block;
  font-size: 16px;
  position: relative;
  padding-left: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.4s;
}

.Item ul li a {
  color: #323232;
  line-height: 24px;
  display: block;
  font-size: 16px;
  position: relative;
  padding-left: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.4s;
}

.Item ul li a:hover {
  transition: all 0.4s;
  color: rgb(28, 116, 205);
}

.Item1 ul li a:hover {
  transition: all 0.4s;
  color: rgb(28, 116, 205);
}

// .Item1 ul li a:before {
//   content: "";
//   width: 3px;
//   height: 3px;
//   // border-radius: 50%;
//   // background-color: #1D4D8A;
//   // border: 3px solid #1e74cd;
//   border-top: 4px solid transparent;
//   border-bottom: 4px solid transparent;
//   border-left: 5px solid #323232;
//   position: absolute;
//   top: 9px;
//   left: 0;
//   // transform: translateY(-50%);
//   // transition: 0.3s;
// }

.Item ul li a:before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  // background-color: #1D4D8A;
  border: 3px solid #1e74cd;
  // border-top: 4px solid transparent;
  // border-bottom: 4px solid transparent;
  // border-left: 4px solid #323232;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  // transition: 0.3s;
}

.Item ul li span {
  width: 4px;
  height: 8px;
  color: #333333;
}

.Item ul li:hover a:before {
  // border-left: 5px solid rgb(28, 116, 205);
  // transition: 0.3s;
}

// 6 块小的专题专栏
.indexTab .tabBox {
  width: 49%;
  // background-color: rgba(223, 222, 222, 0.4);
  // height: 310px;
  // margin-top: 30px;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 5px #f5f5f5;
  margin-bottom: 30px;
}

.dzqk {
  padding-bottom: 20px;
}

.indexTab .tabBox:nth-child(even) {
  margin-left: 2%;
}

.indexTab .tabBox .tabNav {
  margin-top: -2px;
  display: flex;
  width: 100%;
  border-bottom: 2px solid #0b7dda;
}

.indexTab .tabBox .tabNav .txt {
  border: none;
  margin-right: 4%;
}

.indexTab .tabBox .tabNav .txt:last-child {
  margin-right: 0;
}

.indexTab .tabBox .tabNav .txt h3 {
  border: none;
  transition: all 0.5s;
}

.indexTab .tabBox .tabNav .txt h3 a {
  color: #323232;
  transition: all 0.5s;
}

.indexTab .tabBox .tabNav .txt.active h3 {
  border-bottom: 1px solid rgb(28, 116, 205);
  transition: all 0.5s;
  background-color: rgb(28, 116, 205);
  /* 只有第一个标签左上角背景是圆角 */
  /* border-radius: 10px 0 0 0; */
}

.indexTab .tabBox .tabNav .txt.active h3 a {
  color: #fff;
  transition: all 0.5s;
}

.indexTab .tabContainer {
  padding: 10px 24px;
}

.indexTab .tabContainer ul {
  display: none;
}

.indexTab .tabContainer a:hover {
  cursor: pointer;
}

.indexTab .tabContainer ul.active {
  display: block;
}

/*精典图集*/
.indexTab .tabImg ul li {
  width: 30.8%;
  margin-right: 3.75%;
  overflow: hidden;
}

//链接
.searchBox {
  width: 1200px;
  margin: auto;
  background-color: white;
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 5px 5px #f5f5f5;
  box-shadow: 0px 0px 5px 5px #f5f5f5;
  padding: 10px 0px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;

  .optionBox {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 900;

    .text {
      margin-right: 10px;
    }
  }
}

.el-input__inner {
  background-color: rgb(242, 243, 247);
}

.li001 {
  width: 525px;
  margin-right: 5px;

}

.lcss1 {
  display: flex;
  justify-content: space-between;
  padding: 0px 10px 10px 10px;
}

.citylist {
  display: none;
}

.st-box {
  display: none;
  overflow: hidden;
}

.dsj .content.list {
  display: none;
}

.ebook-item {
  img {
    width: 270px;
    height: 330px;
    margin-top: 30px;
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .column-box {
    display: initial;
  }

  .nodata {
    width: 100% !important;
    font-size: 24px !important;
  }

  // 电子期刊
  .swiper {
    overflow: hidden;
    margin-left: 0px !important;

    .img {
      width: 130px;
      height: 190px;
      margin-left: -18px;
    }
  }

  .timeline-wrapper {
    display: none;
  }

  .bottomLink {
    width: 100% !important;
  }

  .tabBox .tabNav .txt:nth-child(1) h3 {
    border-radius: 0 !important;
  }

  .Item ul {
    overflow: hidden;
  }

  .tabContainer ul div {
    overflow: hidden !important;
  }

  .Item ul li a {
    padding-left: 30px;
  }

  .Item ul li a:before {
    left: 10px;
  }

  .content {
    margin-top: 10px !important;
  }

  .lcss1 {
    display: flex;
    justify-content: space-between;
    padding: 0px;

    .head_title {
      padding-left: 30px;
    }

    .head_title:before {
      left: 10px;
      // top: 26%;
    }
  }

  .sheyuan-style {
    width: 100% !important;

    .content {
      width: 100% !important;
      height: auto !important;
    }
  }

  .title:after {
    display: none;
  }

  .tabContainer {
    padding: 0 10px 0 0 !important;
    overflow: hidden !important;
  }

  .li-time {
    display: none;
  }

  .li001 {
    width: auto;
    overflow: hidden;

    a {
      text-overflow: ellipsis;
      // font-size: 12px !important;
      // white-space: wrap !important;
    }

    // a:before {
    //   top: 20% !important;
    // }
  }

  .indexTab .tabBox {
    width: 100%;
    height: auto;
  }

  .Item {
    margin-top: 16px;
  }

  .zhuanlan_more {
    right: 0;
    bottom: 0;
    font-size: 14px !important;
    line-height: 30px !important;
  }

  .tabNav {
    // margin-top: 0 !important;

    .txt {
      height: 40px;
      margin-right: 0 !important;
      line-height: 40px;
    }

    .txt h3 {
      font-size: 15px;
      min-width: none;
      padding: 0;
      line-height: 40px;
    }
  }

  .placeDynamic {
    // display: none;
    width: 100% !important;

    .content {
      margin-top: 0 !important;
    }

    .citylist {
      display: block;
      flex-wrap: wrap;
      display: flex;
      padding: 10px 10px 0 10px;

      .citybox {
        width: 25%;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        padding: 3px;
        box-sizing: border-box;

        &.active {
          background: #0b7dda;
          color: white;
        }
      }
    }

    .item_left {
      display: none;
    }

    .item_right {
      width: 100% !important;
      overflow: hidden;
      padding: 0 10px 10px 10px !important;

      .item {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .sname {
        display: none;
        font-size: 10px !important;
        width: 40px !important;
        height: 26px !important;
        border-radius: 2px !important;
        line-height: 26px !important;
        margin-right: 0 !important;
        white-space: nowrap !important;
      }

      .desc {
        width: 100% !important;
        flex: 1 !important;
      }

      .date {
        display: none;
      }
    }
  }

  .ztzl,
  .dsj,
  .placeDynamic,
  .jingcaizhaopian {
    // width: 41.5rem;
    width: 100%;

    .title {
      padding: 10px 15px;

      p {
        font-size: 16px !important;
        line-height: 30px !important;
      }

      span {
        font-size: 14px;
        line-height: 30px !important;
      }
    }
  }

  .course-type {
    .wrap {
      display: flex !important;
      flex-direction: column !important;

      .tabBox:nth-child(even) {
        margin-left: 0;
      }
    }
  }

  .zhuanti {
    display: flex;
    flex-direction: column;
    width: 100% !important;
  }

  .dsj {
    width: 100% !important;
    padding-bottom: 0 !important;
  }

  .dsj .content {
    display: none !important;
    width: 100% !important;
  }

  .dsj .content.list {
    display: block !important;
    height: auto !important;

    li {
      padding: 8px 0;

      a {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .dashiji.sq {
    display: none;
  }

  .membership .title p {
    font-size: 16px !important;
    line-height: 30px !important;
  }

  .membership .title {
    // padding: 5px !important;
  }

  .membership {
    width: 100% !important;
  }

  .membership .committee {
    width: 100%;

    .content {
      width: 100%;
      height: auto;
    }
  }

  .jingcaizhaopian {
    // width: 41.5rem;
    width: 100%;
    margin-top: 15px;

    .st-box {
      width: 100%;
      height: auto;
      padding: 25px 0;
      display: block;
    }

    .st-box .swiper-wrapper {
      height: auto;
    }

    .st-box .swiper-slide {
      width: 64%;
      padding: 0 2%;
      height: auto;
      margin-top: 0.92593em;
    }

    .st-box .swiper-slide.swiper-slide-active {
      width: 70%;
      margin-top: 0px;
      padding: 0;

      img {
        height: 215px !important;
        object-fit: cover;
      }
    }

    .st-box .swiper-slide img {
      width: 100%;
      height: 183px !important;
      display: block;
      border-radius: 5px;
      box-shadow: 0 0 4px rgba(9, 6, 15, 0.5);
    }

    .pic_content {
      display: none;

      .pic_left img {
        // width: 38.5rem;
        width: 100%;
      }

      .right {
        display: none;
      }
    }

    .pic_left {
      padding: 0 !important;
      width: 100%;
    }

    .pic_smallTitle {
      box-sizing: border-box;
      height: auto !important;
      width: 100% !important;
    }
  }

  .membership {
    display: flex;
    flex-direction: column;

    .committee {
      margin-bottom: 2rem !important;
    }
  }
}

.el-menu-vertical-demo {
  max-height: 560px;
  overflow-y: scroll;
}

::v-deep .el-menu {
  border-right: 1px solid #e6e6e6 !important;
  height: 450px;
}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}

.swiper-container {
  width: 100%;
  height: 240px;
  overflow: hidden !important;
  padding-top: 20px;
  box-sizing: border-box;
}

.swiper-wrapper .swiper-slide {
  width: 350px;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0px 2px 2px 0px #e5edf8;
}

.swiper-wrapper .swiper-slide .img {
  width: 100%;
  height: 100%;
  background-size: 100%;
  border-radius: 4px;
  cursor: pointer;
}

.timeline-wrapper::-webkit-scrollbar {
  width: 4px;
  height: 6px;
}

.timeline-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  opacity: 0.2;
  background-color: #dadada;
}

.timeline-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
}

ul.timeline-wrapper {
  // DS-Digital该字体样式为自定义
  font-family: DS-Digital;
  list-style: none;
  margin: 0;
  padding: 160px 80px;
  white-space: nowrap;
  padding-right: 20px;
  padding-top: 140px;
}

/* 时间线 */
.timeline-item {
  position: relative;
  display: inline-block;
}

.timeline-item .timeline-box {
  text-align: center;
  display: flex;
  align-items: center;
}

.timeline-item .timeline-box .out-circle {
  width: 12px;
  height: 12px;
  background: #39c1e0;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.timeline-item .timeline-box .out-circle .in-circle {
  width: 8px;
  height: 8px;
  margin: 0 auto;
  background: rgba(14, 116, 218, 1);
  border-radius: 50%;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
}

.timeline-item .timeline-box .out-circle .timeline-date {
  color: #333;
  margin-top: 55px;
  position: relative;
}

.timeline-item .timeline-box .out-circle .timeline-date .father-text {
  font-weight: 900;
  font-size: 16px;
  margin-left: -15px;
}

.long-line {
  height: 2px;
  background: rgba(14, 116, 218, 0.2);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: revert;
  justify-content: space-around;
}

.sub-item-box {
  margin-top: -20px;
  position: absolute;
}

.top-sub-item-box {
  left: -60px;
  top: 20px;
}

.bottom-sub-item-box {
  top: 48px;
  left: -60px;
}

.sub-item-box .sub-line-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sub-item-box .sub-line-box .children-line-box {
  width: 0px;
  border-left: 1px solid rgba(14, 116, 218, 0.3);
}

.sub-item-box .sub-line-box .children-box {
  border: 1px solid rgba(14, 116, 218, 0.3);
  padding: 5px;
  white-space: initial;
  width: 120px;
}

.top-line-box {
  margin-top: -120px;
  height: 60px;
}

.bottom-line-box {
  margin-top: -20px;
  height: 150px;
}

.top-line {
  height: 100px;
}

.bottom-line {
  height: 40px;
}

.top-children-box {
  margin-top: -115px;
  background-color: #e2e2e2;
  border-radius: 5px;
  width: 100px;
}

.bottom-children-box {
  background-color: #e2e2e2;
  border-radius: 5px;
  width: 150px;
}

.timeline-content {
  box-sizing: border-box;
  margin-left: 20px;
  height: 106px;
  padding: 0 0 0 20px;
  text-align: left;
  margin-bottom: 30px;
}

.timeline-content .timeline-title {
  font-size: 14px;
  word-break: break-all;
  margin-bottom: 16px;
  color: #333;
  font-weight: 500;
  /*display: inline;*/
}

.timeline-content .timeline-desc {
  font-size: 14px;
  color: #999999;
}

.timeline-item:last-of-type .timeline-content {
  margin-bottom: 0;
}
</style>
